// src/api/itmVrntPkgSuplrsPriceService.js ver 00 Jan 15 2026 9:36 pm SB120
import { callCloudFunction } from './apiClient';

export const getItmVrntPkgSuplrsPrices = async (tenantid, token, page = 1, limit = 20, supplierCodeFilter = 'no-filter', itmVrntPkgNameFilter = 'no-filter') => {
  return callCloudFunction('itmVrntPkgSuplrsPriceCrud', 'GET', null, null, token, null,{
      pathParams: { tenantid, operation: 'list' },
      // queryParams: { page, limit, suppliercodefilter: supplierCodeFilter, itmVrntPkgnamefilter: itmVrntPkgNameFilter }
      queryParams: { page, limit, suppliercodefilter: supplierCodeFilter, itmvrntpkgnamefilter: itmVrntPkgNameFilter }
  });
};

export const getItmVrntPkgSuplrsPriceById = async (tenantid, id, token) => {
  return callCloudFunction('itmVrntPkgSuplrsPriceCrud', 'GET', null, id, token, null,{
      pathParams: { tenantid, operation: 'getById', id }
  });
};

export const addItmVrntPkgSuplrsPrice = async (tenantid, priceData, token) => {
  return callCloudFunction('itmVrntPkgSuplrsPriceCrud', 'POST', priceData, null, token, null,{
      pathParams: { tenantid, operation: 'add' }
  });
};

export const updateItmVrntPkgSuplrsPrice = async (tenantid, id, priceData, token) => {
  return callCloudFunction('itmVrntPkgSuplrsPriceCrud', 'PUT', priceData, null, token, null,{
      pathParams: { tenantid, operation: 'update', id }
  });
};